import { render, staticRenderFns } from "./RecipeList.vue?vue&type=template&id=08c97a79&scoped=true&"
import script from "./RecipeList.vue?vue&type=script&lang=js&"
export * from "./RecipeList.vue?vue&type=script&lang=js&"
import style0 from "./RecipeList.vue?vue&type=style&index=0&id=08c97a79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c97a79",
  null
  
)

export default component.exports